import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import React from 'react'

import { Button } from 'antd'
import { PropTypes } from 'prop-types'

import { PERFORMANCE_GROUPS_DISPLAY } from '../../../constants'
import { conditionedClassName } from '../../../helpers/common'

export const CeremonyMusicGroupTab = observer(
  ({
    title,
    onTabClick,
    onArrowClick,
    noGroup,
    group,
    thumbnail,
    hasCurSelectedItem,
  }) => (
    <div
      className={conditionedClassName({
        'band-modal-content-ceremony-group-item': true,
        'has-current': hasCurSelectedItem,
      })}
      onClick={() => onTabClick?.(group) || onArrowClick?.(group)}
      aria-hidden="true"
    >
      <div className="band-modal-content-ceremony-group-item__wrapper">
        {!noGroup && (
          <img
            className="band-modal-content-ceremony-group-item__thumb"
            src={thumbnail}
            alt=""
          />
        )}
        {noGroup && (
          <div className="band-modal-content-ceremony-group-item__thumb no-cat">
            <img src="/images/no-cat-icon.svg" alt="no-cat-icon" />
          </div>
        )}
        <p className="band-modal-content-ceremony-group-item__name">
          {title || PERFORMANCE_GROUPS_DISPLAY[group]}
          <Button
            className="band-modal-content-ceremony-group-item__button"
            type="link"
          >
            <span>{hasCurSelectedItem ? 'Selected' : 'See options'}</span>
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="font-awesome-icon"
            />
          </Button>
        </p>
      </div>
    </div>
  )
)

CeremonyMusicGroupTab.propTypes = {
  onTabClick: PropTypes.func,
  onArrowClick: PropTypes.func,
  group: PropTypes.number.isRequired,
  noGroup: PropTypes.bool,
  performance: MobxPropTypes.objectOrObservableObject,
  thumbnail: PropTypes.string,
}

CeremonyMusicGroupTab.defaultProps = {
  onTabClick: null,
  onArrowClick: null,
  performance: {},
  noGroup: false,
  thumbnail: '/images/no-music.png',
}
